import * as Yup from "yup";


const emailValidation = Yup.string()
  .matches(
    /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
    "Please enter a valid email format (e.g., user@example.com)"
  )
  .email("Invalid email address")
  .required("Email is required");

const passwordValidation = Yup.string()
  .min(6, "Password must be at least 6 characters")
  .required("Password required")
// .matches(/[A-Z]/, "Password must contain at least one uppercase letter")
// .matches(/[a-z]/, "Password must contain at least one lowercase letter")
// .matches(/[0-9]/, "Password must contain at least one number")
// .matches(/[@$!%*?&]/, "Password must contain at least one special character (@$!%*?&)")
// .required("Password is required");

const passwordValidationForNewPassword = Yup.string()
  .min(6, "New password must be at least 6 characters")
  .matches(/[A-Z]/, "New password must contain at least one uppercase letter")
  .matches(/[a-z]/, "New password must contain at least one lowercase letter")
  .matches(/[0-9]/, "New password must contain at least one number")
  .matches(/[@$!%*?&]/, "New password must contain at least one special character (@$!%*?&)")
  .required("New password is required");

const passwordValidationForCurrentPassword = Yup.string()
  .min(6, "Current password must be at least 6 characters")
  .matches(/[A-Z]/, "Current password must contain at least one uppercase letter")
  .matches(/[a-z]/, "Current password must contain at least one lowercase letter")
  .matches(/[0-9]/, "Current password must contain at least one number")
  .matches(/[@$!%*?&]/, "Current password must contain at least one special character (@$!%*?&)")
  .required("Current password is required");


export const loginValidationSchema = Yup.object().shape({
  // email: emailValidation,
  email: emailValidation,
  password: passwordValidation,
});

export const forgetPassValidationSchema = Yup.object().shape({
  email: emailValidation
})

export const changePasswordValidation = Yup.object().shape({
  currentPassword: passwordValidationForCurrentPassword,
  newPassword: passwordValidationForNewPassword,
  confirmNewPassword: Yup.string()
    .oneOf([Yup.ref("currentPassword"), null], "Current passwords must match")
    .required("Confirm password is required"),
})

export const signupValidationSchema = Yup.object().shape({
  email: emailValidation,
  password: passwordValidation,
  confirmPassword: Yup.string()
    .oneOf([Yup.ref("password"), null], "Passwords must match")
    .required("Confirm password is required"),
  username: Yup.string().min(3, "Username must be at least 3 characters").required("Username is required"),
  firstName: Yup.string()
    .matches(/^[A-Za-z]+$/, "First Name must contain only letters")
    .min(3, "First Name must be at least 3 characters")
    .max(30, "First Name not be  30 characters long")
    .required("First Name is required"),
  lastName: Yup.string()
    .matches(/^[A-Za-z]+$/, "Last Name must contain only letters")
    .min(3, "Last Name must be at least 3 characters")
    .max(30, "Last Name not be  30 characters long")
    .required("Last Name is required"),
});
export const addBlogValidationSchema = Yup.object().shape({})
export const addContactValidationSchema = Yup.object().shape({
  firstName: Yup.string()
    .matches(/^[A-Za-z\s]+$/, "First Name must contain only letters and spaces")
    .min(3, "First Name must be at least 3 characters")
    .max(30, "First Name must not be more than 30 characters long")
    .required("First Name is required"),

  lastName: Yup.string()
    .matches(/^[A-Za-z\s]+$/, "Last Name must contain only letters and spaces")
    .min(3, "Last Name must be at least 3 characters")
    .max(30, "Last Name must not be more than 30 characters long")
    .required("Last Name is required"),

  phone: Yup.string()
    .matches(/^[0-9]{10}$/, "Phone number must be exactly 10 digits")
    .required("Phone Number is required"),
  email: emailValidation,
  address: Yup.string()
    .min(3, "Address must be at least 3 characters")
    .max(300, "Address not be  300 characters long")
    .required("Address is required"),
  message: Yup.string()
    .min(3, "Message must be at least 3 characters")
    .max(300, "Message not be  300 characters long")
    .required("Message is required")
})